var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.69043C6.45312 0.69043 0.6875 6.44324 0.6875 13.5286C0.6875 19.9348 5.37687 25.252 11.5012 26.2129V17.2442H8.24687V13.5286H11.5012V10.697C11.5012 7.48106 13.4103 5.71293 16.3444 5.71293C17.7409 5.71293 19.2016 5.95637 19.2016 5.95637V9.12106H17.5872C15.9984 9.12106 15.4987 10.1076 15.4987 11.1198V13.5286H19.0606L18.4841 17.2442H15.4987V26.2129C18.5179 25.7361 21.2672 24.1956 23.2502 21.8696C25.2332 19.5435 26.3194 16.5852 26.3125 13.5286C26.3125 6.44324 20.5469 0.69043 13.5 0.69043Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoBlack);
export default __webpack_public_path__ + "static/media/FacebookLogoBlack.4f64bff8db000848728e25095f4c5e4b.svg";
export { ForwardRef as ReactComponent };